// English translations
export const en = {
  // Common
  common: {
    home: 'Home',
    settings: 'Settings',
    language: 'Language',
    loading: 'Loading...',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    close: 'Close',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    // Company info
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'Settings',
    home: 'Home',
    howToPlay: 'How to Play',
    pieceRules: 'Piece Rules',
    language: 'Language',
    manageSubscription: 'Manage Subscription',
    gameHistory: 'Game History',
    analytics: 'Analytics',
    premiumAccount: 'Premium Account',
    chatEnabled: 'Chat: On',
    chatDisabled: 'Chat: Off',
  },

  // Piece Rules
  pieceRules: {
    title: 'Piece Rules',
    description: 'Learn piece movement',
    selectPiece: 'Select Piece',
    selectedLabel: 'Selected:',
    statusLabel: 'Status:',
    statusReady: 'Ready',
    statusViewing: 'Viewing',
    movement: 'Movement',
    regularMovement: 'Regular Movement',
    ability: 'Ability',
    backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'Movement',
    savage: 'Savage',
    birdtype: 'Bird Type',
    birdType: 'Bird Type',
    wallBlock: 'Wall Block',
    moveblocks: 'Move Blocks',
    wallclimb: 'Wall Climb',
    lilypad: 'Lilypad',
    poisonous: 'Poisonous',
    meadow: 'Meadow',
    parasiticfungi: 'Parasitic Fungi',
    zombification: 'Zombification',
    fungi: 'Fungi',
    traverse: 'Traverse',
    capture: 'Capture',
    faint: 'Faint',
    leap: 'Leap',
    swing: 'Swing',
    consume: 'Consume',
    gamble: 'Gamble',
    entangle: 'Entangle',
    ink: 'Ink',
    rotate: 'Rotate',
    backstep: 'Back Step',
    trample: 'Trample',
    charge: 'Charge',
    lane: 'Lane',
    snakestrike: 'Snake Strike',
    shedskin: 'Shedskin',
    house: 'House',
    plant: 'Plant Type',
    planttype: 'Plant Type',
    capturehost: 'Capture Host',
    contagion: 'Contagion',
    lonewolf: 'Lone Wolf',
    hop: 'Hop',
    decay: 'Decay',
    slide: 'Slide',
    block: 'Block',
    poison: 'Poison',
    infection: 'Infection',
    howl: 'Howl',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'The Bear can move one square in any direction, like a king in chess',
    bearMovementPost: 'It is only blocked by friendly pieces (except Trees, Bears can climb Trees!)',
    bearSavage: 'A Bear can overcome defensive abilities like the Rhino Block',
    bearSavagePost: 'Using Savage the Bear can capture any piece from any direction, adding lethality',

    // Crane
    craneMovement: 'The Crane can move 1 or 2 squares in any straight line',
    craneMovementPost: 'The Crane can even fly over other pieces!',
    craneBirdType: 'Bird type pieces cannot capture large or predator pieces',
    craneBirdTypePost: 'This includes, Tree, Rhino, Bear and Wolf',

    // Frog
    frogMovement: 'The Frog leaps 2 squares diagonally',
    frogMovementPost: 'It cannot only jump one',
    frogWallBlock: 'If the Frogs regular 2 square path is blocked by a wall or another piece it cannot capture',
    frogWallBlockPost: "It's regular movement is shortened to 1 square diagonally",
    frogWallClimb: 'When the Frog is on the wall of the board (Column A or E) it can move up or down one',
    frogWallClimbPost: 'Unless blocked by a friendly piece or a Rhino infront of the Frog',
    frogLilypad: 'If the Frog has yet to move in a game, it can move to any of the first 3 ranks as a powerful defensive ability',
    frogLilypadPost: 'It can capture any regular piece using Lilypad Jump, except a Rhino on a higher rank than itself',
    frogPoisonous: 'When any animal captures a Frog piece, you become poisoned!',
    frogPoisonousPost: 'A poisoned piece skips its next available turn before it recovers',

    // Fungi
    fungiMovement: 'The Fungi can move one square in any direction',
    fungiMovementPost: 'It is only blocked by ally pieces',
    fungiMeadow: 'The Fungi reduces the movement ability of the enemy Tree piece',
    fungiMeadowPost: 'The enemy Tree piece cannot move within 1 square of the Fungi piece',
    fungiParasitic: 'The Fungi can immobilize the enemy Tree piece',
    fungiParasiticPost: 'If the Fungi is within 1 square of the enemy Tree it cannot move until the Fungi moves away or is captured',
    fungiZombification: 'The Fungi can zombify any enemy animal piece that captures it, allowing control over the enemy animal for one turn',
    fungiZombificationPost: 'The zombified piece is also considered the Fungi piece for that turn, even if the Fungi was your king the game does not end until after that turn',
    fungiFungi: 'The Fungi is a fungus, not an animal so it is immune to several effects',
    fungiFungiPost: 'Like poison, entanglement and virus infection, but not zombification since it can zombify others!',

    // Goat
    goatMovement: 'The Goat can move one square in any direction',
    goatMovementPost: 'The Goat moves slowly but has powerful abilities',
    goatTraverse: 'The Goat can traverse across any other connected pieces to create massive movement potential',
    goatTraversePost: 'The Goat cannot traverse over Fainted Goats or Tiny pieces such as Virus',
    goatCapture: 'The Goat cannot capture any Predators',
    goatCapturePost: 'Such as Bear or Wolf',
    goatFaint: 'The Goat can faint to avoid capture except from large pieces like the Tree and Rhino',
    goatFaintPost: "While fainted, the opponents can 'stand' on the fainted goat to stop its movement",

    // Monkey
    monkeyMovement: 'The Monkey can move one square in any direction',
    monkeyMovementPost: 'Without other pieces to utilize the Monkey has limited movement',
    monkeyLeap: 'The Monkey, like a game of checkers, can leap over other pieces in a straight line for huge movement potential',
    monkeyLeapPost: 'But if leaping over an enemy piece, the Monkey must roll a dice to survive the jump, 1/6th chance of capture for each enemy they leap!',
    monkeySwing: 'If a Monkey uses a leap over a Tree, the Monkey gains a bonus turn',
    monkeySwingPost: 'Using Tree swing creates a powerful synergistic combo between the Monkey and Tree piece',
    monkeyConsume: 'The Monkey can consume a Fungi piece for a bonus turn',
    monkeyConsumePost: 'Leading to devastating combinations when combined with other bonus turns',
    monkeyGamble: 'Besides rolling a dice to leap over enemies, the Monkey must gamble to capture the Bear',
    monkeyGamblePost: 'The monkey must roll a 5 or a 6 on a 6 sided dice to capture the Bear or it is captured itself',

    // Octopus
    octopusMovement: 'The Octopus moves one square in any direction',
    octopusCapture: 'The Octopus can only capture orthangonally',
    octopusCapturePost: 'The octopus can capture or entangle pieces in complex ways so always check for red captures and purple entangles!',
    octopusEntangle: 'The Octopus can entangle adjacent enemy pieces, immobilizing them, it can even move a square and entangle enemies!',
    octopusEntanglePost: 'Entangled pieces cannot move until the Octopus moves away or is captured',
    octopusInk: 'The Octopus can use ink to escape dangerous situations, creating up to 3 shadows',
    octopusInkPost: 'Confusing the enemy and allowing interesting baiting and evasive plays',

    // Penguin
    penguinMovement: 'The Penguin slides in a straight line in its set direction until a wall or piece blocks its movement',
    penguinMovementPost: 'After moving, the Penguin within the same turn can set its final direction as well',
    penguinRotate: 'At the beginning of the match a Penguin is facing down and must rotate before being able to slide, also known as sleeping',
    penguinRotatePost: 'The penguin in any position can choose to rotate instead of moving',
    penguinBirdType: 'The Penguin has limited capture abilities, like the Crane, it cannot capture large or predator pieces like the Tree, Rhino, Bear or Wolf',
    penguinBirdTypePost: 'After capturing, the Penguin can rotate to face any direction for strategic positioning',

    // Rhino
    rhinoMovement: 'The Rhino moves two squares forward only',
    rhinoMovementPost: 'It cannot move only 1 square',
    rhinoBackStep: 'The Rhino can move back-left or back right',
    rhinoCharge: 'The Rhino once per game can travel one extra square forward using its charge ability',
    rhinoChargePost: 'Leading to devastating movement and capture potential',
    rhinoTrample: 'The Rhino captures all pieces in its travel path with Trample',
    rhinoTramplePost: 'Including a fainted Goat piece',
    rhinoLane: 'The Rhino can swap places with another ally piece allowing strategic laning play',
    rhinoLanePost: 'But only if the Rhino and Ally piece have both not moved',

    // Snake
    snakeMovement: 'The Snake can move 2 squares in any straight line',
    snakeMovementPost: 'The Snake moves exactly 2 squares unless blocked by a wall or friendly piece',
    snakeMoveBlocks: "When blocked by a wall or piece it cannot capture, the Snake's movement is shortened to 1 square",
    snakeMoveBlocksPost: 'It can still move two squares even if there is an intermediary piece',
    snakeStrike: "The Snake can strike 3 squares forward if there's an enemy animal",
    snakeStrikePost: 'So long as no intermediary pieces block its path',
    snakeShedskin: 'Once per game, the Snake can shed its skin and return to the first rank if the square is free',
    snakeShedskinPost: 'This rebirth gives the Snake an extra life each game',

    // Tree
    treeMovement: 'The Tree can move one square forward or to any square on its rank side to side',
    treeMovementPost: 'As long as its path is not blocked',
    treeHouse: 'The Tree can house other pieces, protecting them from enemies that cannot climb Trees. Maybe pieces can climb like the Bear, Crane, Frog, Fungi, Goat, Monkey, Octopus and Snake',
    treeHousePost: 'When a piece that can climb a tree attacks, it only captures the housed piece, protecting the Tree',
    treeTrample: 'The Tree like the Rhino, captures all pieces in a square when it moves',
    treeTramplePost: 'This includes a fainted Goat',
    treePlant: 'The Tree is a plant, not an animal so it is immune to several effects',
    treePlantPost: 'Like poison, zombification, entanglement and virus infection!',

    // Virus
    virusMovement: 'The Virus can only move to squares occupied with animals, that are two squares away',
    virusMoveBlocks: 'The Virus can move only one square if it is beside a wall',
    virusCaptureHost: 'When the Virus lands on (in) any animal piece, it only infects them, they can still continue regular play while infected',
    virusCaptureHostPost: 'The Virus only captures the piece when it leaves the infected host',
    virusContagion: 'The Virus can spread rapidly by infecting multiple hosts in a single turn',
    virusContagionPost: 'Contagion allows the Virus to make as many legal moves as it likes each turn',

    // Wolf
    wolfMovement: 'The Wolf can move in an L shape, like the knight in chess',
    wolfMovementPost: 'It is not obstrcuted by any other pieces',
    wolfLoneWolf: 'When the Wolf has no remaining allies, its movement pattern swaps to an elongated L moving an extra square',
    wolfLoneWolfPost: 'The Wolf also considers itself lone when it still has a fainted Goat or a virus ally',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 Drag to explore • Pinch to zoom',
    dragToExploreDesktop: '🖱️ Drag to explore • Scroll to zoom',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'Back',
    next: 'Next',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'SANDBOX',
    description: 'Experiment & Practice',
    mode: 'Mode:',
    modeValue: 'Sandbox',
    status: 'Status:',
    statusReady: 'Ready',
    clearBoard: 'Clear Board',
  },

  // Multiplayer
  multiplayer: {
    title: 'MULTIPLAYER',
    description: 'Find your match and compete!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'Placement Matches',
    matchProgress: 'Match Progress',
    gamesCompleted: '{games} / 10 Games Completed',
    estimatedFinalRating: 'Estimated Final Rating',
    startingRating: 'Starting rating',
    matchesRemaining: '{matches} matches remaining',
    findPlacementMatch: 'Find Placement Match',

    // Matchmaking modes
    findMatch: 'Find Match',
    competitive: 'Competitive',
    competitiveDesc: 'Find opponents close to your ranking',
    quick: 'Quick',
    quickDesc: 'Find competitive matches quickly',
    casual: 'Casual',
    casualDesc: 'Unranked - play for fun!',
    placement: 'Placement',
    placementDesc: 'Complete 10 matches to get ranked',
    startSearch: 'Start Search',

    // Searching
    searching: 'Searching...',
    mode: 'Mode:',
    inQueue: 'In Queue:',
    players: 'player',
    playersPlural: 'players',
    cancelSearch: 'Cancel Search',

    // Game info
    status: 'Status:',
    ready: 'Ready',
    selectingKing: 'Selecting King',
    placingPieces: 'Placing Pieces',
    playing: 'Playing',
    gameType: 'Game Type:',
    opponent: 'Opponent:',
    opponentElo: 'Opponent ELO:',
    unranked: 'Unranked',

    // Piece placement
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces (You)',
    darkPieces: 'Dark Pieces (You)',

    // Waiting states
    waitingForOpponent: 'Waiting for Opponent...',
    waitingForKing: 'Waiting for opponent to select their king...',

    // Warnings
    invalidPlacement: 'Invalid Placement',
    lightTurn: "It's Light player's turn!",
    darkTurn: "It's Dark player's turn!",
    onlyLightPieces: 'You can only place light pieces!',
    onlyDarkPieces: 'You can only place dark pieces!',
    mustPlaceOnRow: '{color} pieces must be placed on row {row}!',

    // Chat
    chat: 'Chat',
    typeMessage: 'Type a message...',
    send: 'Send',
  },

  // Main Page
  mainPage: {
    title: 'ANIMAL CHESS',
    subtitle: 'A game for humans',
    playersOnline: 'Current players online',
    placement: 'Placement',
    placementProgress: 'Placement',
    challengeAI: 'Challenge AI',
    multiplayer: 'Multiplayer',
    sandbox: 'Sandbox',
    tutorials: 'Tutorials',
    shop: 'Shop',
    collection: 'Collection',
    history: 'History',
    analytics: 'Analytics',
    courses: 'Courses',
    upgradeAccount: 'Upgrade account',
    signIn: 'Sign In',
    playAsGuest: 'Play as Guest',
    welcomeBack: 'Welcome back! You usually play as',

    // Learn the Pieces section
    learnThePieces: 'Learn the pieces',

    // Learn the Rules section
    learnTheRules: 'Learn the Rules',
    premiseTitle: 'Premise',
    premiseText: 'Zodiac is a chess alternative with a HIDDEN king from a roster of 13 pieces, select a unique roster and then bluff your opponent to defeat them on a 5 by 8 board',
    selectionTitle: 'Selection',
    selectionText: 'To start a game, secretly choose your king, then place your 5 pieces alternately with your opponent to create one of over 500 billion initial states.',
    objectiveTitle: 'Objective',
    objectiveText: 'Either read your opponent to CAPTURE their secret king or RACE your king across the board to secure victory!',
    competeTitle: 'Compete',
    competeText: 'Test your skills on the ladder, develop new personal techniques and strategies, rank up to take on the best!',
    fullRulesButton: 'For full official rules click here',

    // FAQ section
    faqTitle: 'Frequently Asked Questions',
    faqQuestion1: 'Whats the idea behind Zodiac chess?',
    faqAnswer1: 'Zodiac chess was inspired initially by words from Bobby Fischer about his inspiration to make Chess960, we wanted to expand on the idea of battling rote memorization and celebrating human intuition in unfathomable depth!',
    faqQuestion2: 'Why do we need a chess alternative',
    faqAnswer2: "We don't! Zodiac doesn't want to detract people from playing chess! It's a different option with its own strengths and weaknesses, we hope you have some fun with it and help us adapt this game to enliven novel play",
    faqQuestion3: 'How do you win in Zodiac Chess?',
    faqAnswer3: "There are three ways to win: capture your opponent's hidden king piece, race your own king to the opposite side of the board, or in a match with time controls, have your opponents time run out",
    faqQuestion4: 'Is this a FAQ?',
    faqAnswer4: 'Yes, you can look at any of the listed questions in the FAQ and if you want some more details, you can click on the questions and then read the following details, like these details you are reading now',
    faqQuestion5: 'How long does a typical game take?',
    faqAnswer5: 'Each game differs widly! Some games are over in 2 moves and some might take 30 minutes, we typically tend to find they are the 5-15 minute mark!',
    faqQuestion6: 'What happens if no one can make a legal move?',
    faqAnswer6: 'If a player cannot make any legal move (stalemate), the game ends in a draw. The game can also end in a draw through repetition (same board state 3 times) or by mutual agreement between players!',

    // About section
    aboutButton: 'About',
    privacyPolicy: 'Privacy Policy',
    developerInterface: 'Developer Interface',
  },

  // About Modal
  about: {
    title: 'About Zodiac',
    paragraph1: 'Zodiac is chess-like board game combining elements of piece selection from games like LoL and DotA, with bluffing mechanics from poker or social deduction games.',
    paragraph2: 'Early versions of the game were created in 2014, under the name Shadow Chess. In 2018 it was redesigned to be what you see today, involving a roster of fun pieces with balanced, but unique movement patterns and abilities.',
    paragraph3: 'Our vision is to record all user gameplay data to continue to evolve the game in an effort to keep gameplay refreshing, encouraging novel plays.',
    paragraph4: 'With Zodiacs giant search space, hidden information and opening board positions we hope to stave off AI dominance and keep zodiac a game for humans!',
  },

  // Privacy Policy
  privacy: {
    title: 'Privacy Policy',
    lastUpdated: 'Last Updated',

    introduction: {
      title: 'Introduction',
      p1: 'Welcome to Zodiac Chess ("we," "our," or "us"). We are committed to protecting your privacy and ensuring you have a safe and enjoyable gaming experience. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and game.',
      p2: 'By using Zodiac Chess, you agree to the collection and use of information in accordance with this policy. If you do not agree with our policies and practices, please do not use our service.',
      contact: 'Contact us at:',
    },

    infoCollect: {
      title: 'Information We Collect',
      accountInfo: {
        title: '1. Account Information',
        item1: 'Email Address: Required for account creation and communication',
        item2: 'Username: Your chosen display name',
        item3: 'Password: Encrypted and securely stored',
      },
      gameData: {
        title: '2. Game Data',
        item1: 'Game Statistics: Wins, losses, ELO rating, placement match progress',
        item2: 'Gameplay Data: Piece selections, moves made, strategies used',
        item3: 'Match History: Records of games played, opponents faced',
        item4: 'In-Game Purchases: Cosmetic items and premium membership status',
      },
      technicalData: {
        title: '3. Technical Data',
        item1: 'Device Information: Browser type, operating system',
        item2: 'Usage Data: Pages visited, time spent, features used',
        item3: 'Local Storage: Language preferences, UI settings, temporary game state',
      },
    },

    children: {
      title: 'Children\'s Privacy (COPPA Compliance)',
      p1: 'Zodiac Chess is designed to be family-friendly and suitable for players of all ages, including children. We take special care to comply with the Children\'s Online Privacy Protection Act (COPPA).',
      p2: 'For users under 13 years of age: We recommend that children use our guest play mode, which does not require account creation or data collection. Guest accounts do not have access to text chat features, ensuring children are not exposed to communication with the wider internet. If a child creates an account, we require parental consent before collecting any personal information.',
      p3: 'We do NOT knowingly collect, use, or share personal information from children under 13 without verified parental consent.',
      p4: 'Chat Safety: Text chat is automatically disabled for all guest/temporary accounts. Standard account holders have the option to disable chat functionality in their account settings at any time.',
      parentalRights: 'Parents have the right to:',
      right1: 'Review their child\'s personal information',
      right2: 'Request deletion of their child\'s data',
      right3: 'Refuse further collection or use of their child\'s information',
      contactUs: 'To exercise these rights or if you believe your child has provided us with personal information, please contact us immediately at contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'How We Use Your Information',
      item1: 'Provide and improve our game services',
      item2: 'Match you with appropriate opponents based on skill level',
      item3: 'Track your progress, statistics, and achievements',
      item4: 'Process payments for premium memberships and cosmetic items',
      item5: 'Send important service announcements and updates',
      item6: 'Analyze gameplay data to improve game balance and features',
    },

    thirdParty: {
      title: 'Third-Party Services',
      firebase: {
        title: 'Firebase (Google)',
        description: 'We use Firebase for authentication, database storage, and multiplayer functionality. Firebase may collect certain data as described in their privacy policy.',
      },
      stripe: {
        title: 'Stripe',
        description: 'We use Stripe to process payments for premium memberships and in-app purchases. Stripe handles all payment card information - we never see or store your full payment details.',
      },
      netlify: {
        title: 'Netlify',
        description: 'Our website is hosted on Netlify, which may collect standard web hosting data such as IP addresses and access logs.',
      },
      adsense: {
        title: 'Google AdSense (Future)',
        description: 'We may display advertisements through Google AdSense. These ads may use cookies for personalization. For child-directed content, we will only show non-personalized ads in compliance with COPPA.',
      },
      viewPolicy: 'View their Privacy Policy',
    },

    cookies: {
      title: 'Cookies and Local Storage',
      description: 'We use browser local storage (similar to cookies) to enhance your experience:',
      item1: 'Language Preference: Remember your selected language',
      item2: 'Account Session: Keep you logged in (works with Firebase)',
      item3: 'Game Settings: Remember your UI preferences and sandbox setups',
      item4: 'Advertising Cookies: If you consent, third-party ad services may use cookies for ad personalization',
    },

    security: {
      title: 'Data Security',
      p1: 'We implement appropriate security measures to protect your information:',
      item1: 'Password Encryption: All passwords are encrypted using industry-standard methods',
      item2: 'Secure Connections: HTTPS encryption for all data transmission',
      item3: 'Firebase Security Rules: Strict database access controls',
      p2: 'However, no method of transmission over the internet is 100% secure. While we strive to protect your data, we cannot guarantee absolute security.',
    },

    retention: {
      title: 'Data Retention',
      p1: 'We retain your data as follows:',
      item1: 'Active Accounts: Data is retained while your account is active',
      item2: 'Inactive Accounts: If your account is inactive for 10 years, we may delete your data',
    },

    rights: {
      title: 'Your Privacy Rights',
      description: 'Depending on your location, you may have the following rights:',
      access: {
        title: 'Access:',
        description: 'Request a copy of your personal data',
      },
      correction: {
        title: 'Correction:',
        description: 'Request corrections to your data',
      },
      deletion: {
        title: 'Deletion:',
        description: 'Request deletion of your account and data',
      },
      portability: {
        title: 'Data Portability:',
        description: 'Request your data in a portable format',
      },
      optOut: {
        title: 'Opt-Out:',
        description: 'Opt out of marketing communications',
      },
      contact: 'To exercise any of these rights, please contact us at contact@zodiac-chess.com',
    },

    international: {
      title: 'International Users',
      p1: 'Zodiac Chess is operated from New Zealand. If you are accessing our service from outside New Zealand, please be aware that your information may be transferred to, stored, and processed in New Zealand and other countries where our service providers operate.',
      p2: 'By using our service, you consent to the transfer of your information to countries outside your country of residence, which may have different data protection laws.',
    },

    changes: {
      title: 'Changes to This Privacy Policy',
      description: 'We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Last Updated" date. Significant changes will be communicated through email or a prominent notice on our website.',
    },

    contact: {
      title: 'Contact Us',
      description: 'If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us:',
      email: 'Email:',
      company: 'Company:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'Terms of Service',
    lastUpdated: 'Last Updated',
    back: 'Back',
    viewPrivacyPolicy: 'View Privacy Policy',
    acknowledgment: 'By using Zodiac Chess, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.',
    acceptance: {
      title: '1. Acceptance of Terms',
      p1: 'By accessing and using Zodiac Chess (the "Service"), you accept and agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service.',
      p2: 'We reserve the right to modify these terms at any time. Continued use of the Service after changes constitutes acceptance of the modified terms.',
    },
    description: {
      title: '2. Description of Service',
      p1: 'Zodiac Chess is an online strategy board game featuring unique animal pieces with special abilities. The Service includes:',
      feature1: 'Single-player gameplay against AI opponents',
      feature2: 'Multiplayer matchmaking and competitive play',
      feature3: 'Interactive tutorials and learning resources',
      feature4: 'Account creation and progression tracking',
      feature5: 'Optional premium subscription features',
      feature6: 'Cosmetic customization options',
    },
    accounts: {
      title: '3. User Accounts',
      eligibility: {
        title: '3.1 Eligibility',
        p1: 'You must be at least 13 years old to create an account. Users under 13 may use guest play mode with parental supervision but cannot create accounts.',
      },
      responsibilities: {
        title: '3.2 Account Security',
        p1: 'You are responsible for:',
        item1: 'Maintaining the confidentiality of your password',
        item2: 'All activities that occur under your account',
        item3: 'Notifying us immediately of any unauthorized use',
        p2: 'We are not liable for any loss or damage arising from unauthorized account access.',
      },
      prohibited: {
        title: '3.3 Prohibited Activities',
        p1: 'You may NOT:',
        item1: 'Share your account with others',
        item2: 'Use multiple accounts to manipulate rankings',
        item3: 'Use bots, scripts, or automated tools to play games',
        item4: 'Harass, abuse, or threaten other players',
        item5: 'Exploit bugs or glitches for unfair advantage',
        item6: 'Reverse engineer or attempt to access our source code',
        p2: 'Violation of these rules may result in account suspension or permanent ban.',
      },
    },
    premium: {
      title: '4. Premium Subscriptions',
      billing: {
        title: '4.1 Billing',
        p1: 'Premium subscriptions are processed through Stripe. By purchasing a premium subscription, you authorize us to charge your payment method on a recurring basis until you cancel.',
        p2: 'Subscription fees are:',
        item1: 'Monthly Plan: Charged monthly on the anniversary of your purchase date',
        item2: 'Annual Plan: Charged annually on the anniversary of your purchase date',
        p3: 'Prices are subject to change with 30 days notice to active subscribers.',
      },
      cancellation: {
        title: '4.2 Cancellation',
        p1: 'You may cancel your subscription at any time through your account settings or by contacting support. Cancellation takes effect at the end of your current billing period.',
        p2: 'You will retain premium features until the end of your paid period, even after cancellation.',
      },
      refunds: {
        title: '4.3 Refunds',
        p1: 'Monthly subscriptions: No refunds for partial months. Cancel anytime to stop future charges.',
        p2: 'Annual subscriptions: Full refund if requested within 7 days of purchase. After 7 days, refunds are at our discretion.',
        p3: 'Cosmetic purchases: Generally non-refundable. Contact support for exceptional circumstances.',
      },
    },
    acceptable: {
      title: '5. Acceptable Use Policy',
      p1: 'You agree to use Zodiac Chess in a respectful and lawful manner. Prohibited conduct includes:',
      item1: 'Cheating, hacking, or exploiting game mechanics',
      item2: 'Harassment, hate speech, or discriminatory language',
      item3: 'Spamming, advertising, or solicitation',
      item4: 'Sharing inappropriate content (if chat or user-generated content is enabled)',
      item5: 'Impersonating other users or staff members',
      item6: 'Attempting to disrupt or damage the Service',
      p2: 'We reserve the right to investigate violations and take appropriate action, including account termination and reporting to authorities if necessary.',
    },
    intellectual: {
      title: '6. Intellectual Property Rights',
      ownership: {
        title: '6.1 Our Content',
        p1: 'All game content, including but not limited to game mechanics, artwork, animations, sound effects, code, and design, are owned by Animal Chess Limited or our licensors.',
        p2: 'You are granted a limited, non-exclusive, non-transferable license to use the Service for personal entertainment purposes only.',
      },
      userContent: {
        title: '6.2 User Content',
        p1: 'By submitting content (such as chat messages, usernames, or profile information), you grant us a worldwide, royalty-free license to use, display, and distribute that content in connection with the Service.',
        p2: 'You represent that you own or have the necessary rights to any content you submit.',
      },
    },
    disclaimers: {
      title: '7. Disclaimers and Limitations of Liability',
      p1: 'THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED.',
      p2: 'We do not guarantee that:',
      item1: 'The Service will be uninterrupted or error-free',
      item2: 'Defects will be corrected',
      item3: 'The Service is free of viruses or harmful components',
      item4: 'Results from using the Service will meet your expectations',
      p3: 'TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE ARE NOT LIABLE FOR:',
      item5: 'Any indirect, incidental, or consequential damages',
      item6: 'Loss of profits, data, or goodwill',
      item7: 'Service interruptions or data loss',
      item8: 'Damages exceeding the amount you paid us in the past 12 months',
    },
    privacy: {
      title: '8. Privacy',
      p1: 'Your use of the Service is also governed by our Privacy Policy, which explains how we collect, use, and protect your personal information.',
      p2: 'By using the Service, you consent to our data practices as described in the Privacy Policy.',
    },
    changes: {
      title: '9. Changes to Terms',
      p1: 'We reserve the right to modify these Terms of Service at any time. We will notify users of material changes via:',
      item1: 'Email notification to registered users',
      item2: 'Prominent notice on the website',
      item3: 'Updated "Last Updated" date at the top of this page',
      p2: 'Your continued use of the Service after changes constitutes acceptance of the modified terms.',
    },
    governing: {
      title: '10. Governing Law',
      p1: 'These Terms of Service are governed by the laws of New Zealand, without regard to conflict of law principles.',
      p2: 'Any disputes arising from these terms or your use of the Service shall be resolved in the courts of New Zealand.',
    },
    contact: {
      title: '11. Contact Information',
      p1: 'For questions, concerns, or support regarding these Terms of Service:',
      email: 'Email:',
      company: 'Company:',
      address: 'Address:',
    },
    severability: {
      title: '12. Severability',
      p1: 'If any provision of these terms is found to be unenforceable or invalid, that provision will be limited or eliminated to the minimum extent necessary, and the remaining provisions will remain in full force and effect.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'Cookie Policy',
    lastUpdated: 'Last Updated',
    // Browser instructions
    browserInstructions: {
      chrome: 'Settings → Privacy and Security → Cookies',
      firefox: 'Settings → Privacy & Security → Cookies and Site Data',
      safari: 'Preferences → Privacy → Cookies and website data',
      edge: 'Settings → Privacy, search, and services → Cookies',
    },
    // Cookie table headers
    cookieTable: {
      name: 'Cookie Name',
      purpose: 'Purpose',
      duration: 'Duration',
      type: 'Type',
    },
    // Related Policies
    relatedPolicies: {
      title: 'Related Policies',
      description: 'For more information about how we handle your data, please see:',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
    },
    introduction: {
      title: 'Introduction',
      p1: 'This Cookie Policy explains how Zodiac Chess ("we," "our," or "us") uses cookies and similar technologies when you visit our website.',
      p2: 'By using our website, you consent to our use of cookies in accordance with this policy. If you do not agree, please disable cookies in your browser settings or do not use our website.',
    },
    what: {
      title: 'What Are Cookies?',
      p1: 'Cookies are small text files that are placed on your device (computer, smartphone, tablet) when you visit a website. They are widely used to make websites work efficiently and provide information to website owners.',
      p2: 'Cookies serve various purposes, including remembering your preferences, analyzing site usage, and enabling certain features.',
    },
    types: {
      title: 'Types of Cookies We Use',
      necessary: {
        title: '1. Necessary Cookies',
        description: 'These cookies are essential for the website to function properly. Without these cookies, services you have requested cannot be provided.',
        examples: 'Examples:',
        item1: 'Authentication cookies - Keep you logged into your account',
        item2: 'Security cookies - Protect against fraudulent activity',
        item3: 'Session cookies - Maintain your game state during a session',
        item4: 'Cookie consent preferences - Remember your cookie choices',
      },
      analytics: {
        title: '2. Analytics Cookies',
        description: 'These cookies help us understand how visitors interact with our website by collecting anonymous information about page visits, time spent, and features used.',
        provider: 'Provider: Firebase Analytics (Google)',
        purpose: 'Purpose:',
        item1: 'Measure website traffic and user engagement',
        item2: 'Identify popular features and pages',
        item3: 'Understand user demographics (age range, general location)',
        item4: 'Improve website performance and user experience',
      },
      advertising: {
        title: '3. Advertising Cookies',
        description: 'These cookies are used to display advertisements that are relevant to you. They also limit the number of times you see an ad and help measure the effectiveness of advertising campaigns.',
        provider: 'Provider: Google AdSense',
        purpose: 'Purpose:',
        item1: 'Show personalized ads based on your interests',
        item2: 'Measure ad performance and engagement',
        item3: 'Prevent showing the same ad too many times',
        note: 'Note: Premium subscribers never see advertisements, regardless of cookie settings.',
      },
    },
    firstThird: {
      title: 'First-Party vs Third-Party Cookies',
      firstParty: {
        title: 'First-Party Cookies',
        description: 'These are cookies set directly by Zodiac Chess. We use them for essential site functionality, authentication, and remembering your preferences.',
      },
      thirdParty: {
        title: 'Third-Party Cookies',
        description: 'These are cookies set by external services we use, such as Google Analytics and Google AdSense. Third-party cookies are subject to the privacy policies of those providers.',
      },
    },
    specific: {
      title: 'Specific Cookies We Use',
      tableHeader: 'Below is a detailed list of the cookies used on our website:',
    },
    control: {
      title: 'How to Control Cookies',
      consent: {
        title: '1. Cookie Consent Banner',
        description: 'When you first visit our website, you will see a cookie consent banner. You can:',
        item1: 'Accept All - Allow all cookies (necessary, analytics, and advertising)',
        item2: 'Reject Optional - Only allow necessary cookies (no analytics or ads)',
        item3: 'Customize - Choose exactly which types of cookies you want to allow',
      },
      browser: {
        title: '2. Browser Settings',
        description: 'Most web browsers allow you to control cookies through their settings. You can:',
        item1: 'Block all cookies',
        item2: 'Accept only first-party cookies',
        item3: 'Delete cookies after each browsing session',
        item4: 'View and delete individual cookies',
        links: 'Here are links to cookie management for popular browsers:',
      },
      optOut: {
        title: '3. Opt-Out Tools',
        description: 'For advertising cookies specifically, you can opt out of personalized ads:',
        googleLink: 'Google Ad Settings',
        googleDesc: ' - Manage Google personalized ads',
        daaLink: 'Digital Advertising Alliance (DAA)',
        daaDesc: ' - Opt out of interest-based advertising',
        edaaLink: 'European Interactive Digital Advertising Alliance (EDAA)',
        edaaDesc: ' - EU-specific opt-out tool',
      },
    },
    impact: {
      title: 'Impact of Disabling Cookies',
      p1: 'If you disable or refuse cookies, please note that:',
      item1: 'Some parts of the website may not function properly',
      item2: 'You may need to re-enter your preferences each visit',
      item3: 'You may be logged out of your account',
      item4: 'Necessary cookies are required for the site to work - disabling them will prevent you from using core features',
    },
    updates: {
      title: 'Updates to This Cookie Policy',
      p1: 'We may update this Cookie Policy from time to time to reflect changes in our practices or for legal, regulatory, or operational reasons.',
      p2: 'We will notify you of significant changes by updating the "Last Updated" date at the top of this page. Please review this policy periodically.',
    },
    contact: {
      title: 'Contact Us',
      p1: 'If you have questions about our use of cookies or this Cookie Policy, please contact us:',
      email: 'Email:',
      company: 'Company:',
    },
  },

  // Game
  game: {
    yourTurn: 'Your Turn',
    opponentTurn: "Opponent's Turn",
    victory: 'Victory!',
    defeat: 'Defeat',
    draw: 'Draw',
    resign: 'Resign',
    offerDraw: 'Offer Draw',
  },

  // Game End Popup
  gameEnd: {
    victory: 'VICTORY!',
    defeat: 'DEFEAT!',
    draw: 'DRAW!',
    wonBy: 'Won by {condition}',
    lostBy: 'Lost by {condition}',
    drawBy: 'Draw by {condition}',
    youCapturedTheirKing: 'You captured their {piece} King!',
    yourKingWasCaptured: 'Your {piece} King was captured!',
    rematchButton: 'Rematch',
    backButton: 'Back',
    conditions: {
      kingslayer: 'Kingslayer',
      race: 'Race Victory',
      timeout: 'Opponent Time Out',
      threefold: '3x Repetition',
      noMoves: 'No Valid Moves',
      draw: 'Draw',
    },
  },

  // Game Info
  gameInfo: {
    title: 'Game Info',
    sandboxMode: 'Sandbox Mode',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
    yourTurn: 'Your turn',
    opponentTurn: "Opponent's turn",
    aiThinking: 'AI thinking...',

    // Selection states
    selecting: 'Selecting {piece}',
    observing: 'Observing {piece}',
    selectingZombified: 'Selecting zombified enemy {piece}',
    selectionLocked: 'Selection locked on {piece}',
    selectionLockedPenguin: 'Penguin is selection locked',

    // Hints
    clickToFaint: 'Click on {piece} to faint',
    clickToRotate: 'Click on the {piece} to rotate',
    clickToInk: 'Click on the {piece} to ink',
    zombifiedWarning: '⚠️ While zombified, {piece} rotates before moving!',

    // Monkey bonus turn
    monkeySwing: 'Monkey completed swing, please move your Monkey to complete bonus turn',
    monkeyConsume: 'Monkey consumed fungi, please move your Monkey to complete bonus turn',

    // Virus bonus turn
    virusInfecting: 'Virus is infecting, continue turn or click on virus to end turn',

    // Penguin bonus turn
    penguinRotate: 'Penguin completed slide - please choose final rotation direction',
    penguinCaptureRotate: 'Penguin completed capture - please choose final rotation direction',
    penguinZombified: 'Zombified Penguin rotated - complete turn with slide/capture (zombification will end)',

    // Capture restrictions
    cannotCapture: '{piece} cannot capture: {targets}',
    cannotInfect: '{piece} cannot infect: {targets}',
    cannotEntangle: '{piece} cannot entangle: {targets}',
    monkeyBearRoll: '{piece} must roll 5-6 to capture enemy {target}',

    // Immunity info (cannot be captured by)
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',

    // Meadow warning (Tree immobilization)
    meadowWarning: '{piece} is immobilized by enemy {fungi}',

    // Rhino charge warning (cannot charge plants/virus)
    rhinoChargeWarning: '{piece} charge does not affect: {targets}',

    // Snake strike warning (cannot strike plants/virus)
    snakeStrikeWarning: '{piece} strike does not affect: {targets}',
  },

  // Piece names
  pieces: {
    Bear: 'Bear',
    Crane: 'Crane',
    Frog: 'Frog',
    Fungi: 'Fungi',
    Goat: 'Goat',
    Monkey: 'Monkey',
    Octopus: 'Octopus',
    Penguin: 'Penguin',
    Rhino: 'Rhino',
    Snake: 'Snake',
    Tree: 'Tree',
    Virus: 'Virus',
    Wolf: 'Wolf',
  },

  // Short poetic vibe descriptions for landing carousel — one per variant
  pieceVibes: {
    Bear:    { light: 'Few dare approach',                   dark: 'Nothing impedes her hunger' },
    Crane:   { light: 'Sailing above, quieter than the wind',      dark: 'It circles. It waits. The lonely never return home' },
    Frog:    { light: 'Lazing on the lily pad',       dark: 'Take the colors as a warning' },
    Fungi:   { light: 'The meadow-maker',         dark: 'Consume and see who has been consumed' },
    Goat:    { light: 'Catch me on the cliff side',   dark: 'The corpse that blinks' },
    Monkey:  { light: 'Branch to branch to foe, laughing all the way',               dark: 'Roll the bones. Smiles either way' },
    Octopus: { light: 'Soft arms, razor sharp hooks, never releasing its grip',  dark: 'A bloom of black water. The shape inside is gone' },
    Penguin: { light: 'A harmless little thing in a tiny black coat',        dark: 'Slow and cute, right?' },
    Rhino:   { light: 'Waiting to face down a challenger', dark: 'Lock eyes at your peril' },
    Snake:   { light: 'Changing endings like outfits',                               dark: 'Do not tread near me' },
    Tree:    { light: 'A haven amongst the beasts',             dark: 'Standing where the dead stood. Still standing' },
    Virus:   { light: 'The battle for pandoras box',         dark: 'They feel triumph, then a cough, then silent disbelief' },
    Wolf:    { light: 'The alpha of his pack',  dark: 'When the pack is gone. What remains excites' },
  },


  // Move Context — header + empty-state for the right-side panel on the Piece Rules page.
  // All per-piece text comes from live animation scenarios; no static fallback.
  moveContext: {
    title: 'Move Context',
    emptyState: 'Select an ability from the left panel to view detailed information.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'AI ARENA',
    tagline: 'Pick an AI to Battle or watch AI duke it out!',

    // Player labels
    lightPlayer: 'Light Player',
    darkPlayer: 'Dark Player',
    humanPlayer: 'Human Player',
    aiPlayer: 'AI',

    // Difficulty
    difficulty: 'Difficulty',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'Sentinel',
    aiAlchemist: 'Alchemist',
    aiZenith: 'Zenith',
    aiTrapper: 'Trapper',
    aiHunter: 'Hunter',
    aiWisp: 'Wisp',
    aiCreature: 'Creature',
    aiWeaver: 'Weaver',

    // Time Frames
    timeFast: 'Fast',
    timeStandard: 'Standard',
    timeDeep: 'Deep',

    // Thinking time
    thinkingTime: 'Thinking Time',

    // Info box
    matchupLabel: 'Matchup:',
    statusLabel: 'Status:',
    statusPaused: 'PAUSED',
    statusAIThinking: 'AI Thinking...',
    statusInGame: 'In Game',
    statusReady: 'Ready',
    matchupLocal2P: 'Local 2P',
    matchupPlayerVs: 'Player vs',
    matchupVsPlayer: 'vs Player',

    // Buttons
    startButton: 'Start',
    startRandomButton: 'Start Random',
    newGameButton: 'Reset',
    resumeButton: 'Resume',
    pauseButton: 'Pause',
    pauseQueuedButton: 'Pause (queued...)',
    viewKingsButton: 'View Kings',
    hideKingsButton: 'Hide Kings',
    viewKingsQueuedButton: 'View Kings (queued...)',
    hideKingsQueuedButton: 'Hide Kings (queued...)',
    homeButton: 'Home',
    toggleKingVisibility: 'Toggle king visibility',

    // Warning modal
    invalidPlacement: 'Invalid Placement',
    okButton: 'OK',
    warningLightTurn: "It's Light player's turn to place a piece!",
    warningDarkTurn: "It's Dark player's turn to place a piece!",
    warningLightRow: 'Light pieces must be placed on row 0 (your home row)!',
    warningDarkRow: 'Dark pieces must be placed on row 7 (your home row)!',
    warningOccupied: 'This square is already occupied! Choose an empty square.',
    warningKingRequired: 'You must place your king ({kingType}) before placing your 5th piece!',

    // Piece selection
    dragPieces: 'Drag pieces to the board',
    lightPieces: 'Light Pieces',
    darkPieces: 'Dark Pieces',

    // Mobile
    selectYourKing: 'Select Your King',
    selectPieceToPlace: 'Select Piece to Place',
    moveHistory: 'Move History',
    historyButton: 'History',
    backButton: 'Back',
    lightTurn: "Light's turn",
    darkTurn: "Dark's turn",
  },

  // Upgrade Modal
  upgrade: {
    title: 'Upgrade to Premium',
    accountRequired: 'You need to create a permanent account before upgrading to premium.',
    createAccountPrompt: 'Create an account to save your progress and unlock premium features!',
    subtitle: 'Unlock powerful features to enhance your Zodiac Chess experience!',
    features: {
      history: 'Account History',
      historyItem1: 'Store and recall all your previous games',
      historyItem2: 'Replay your old games from anypoint to evaluate strategy',
      historyItem3: 'Use deep analytics to analyse board positions and brilliant move opportunities',
      analytics: 'Analytics',
      analyticsItem1: 'Get access to game stats',
      analyticsItem2: 'Analyse users piece and king selection across tonnes of metrics',
      analyticsItem3: 'Find out what metas are popular and whats working!',
      course: 'Course',
      courseItem1: 'Get access to upto date courses to develop your skill',
      courseItem2: "Learn meta's and concepts from the pro's",
      courseItem3: 'Get tips on your own game play to analyse your own weaknesses',
    },
    createAccount: 'Create Account',
    upgradeNow: 'Upgrade Now',
    cancel: 'Cancel',
  },

  // Premium Modal
  premium: {
    title: 'Premium Feature',
    accessDenied: 'Sorry you do not have a premium account, you do not have access to these features yet!',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'Oops! Something Went Wrong',
    errorMessage: "We encountered an issue processing your payment. Don't worry, you haven't been charged.",
    whatHappened: 'What happened?',
    notCompleted: "Your payment wasn't completed. This could be due to:",
    reasons: {
      cancelled: 'Payment was cancelled',
      declined: 'Card was declined',
      connection: 'Connection issue during checkout',
      expired: 'Session expired',
    },
    whatToDo: 'What can you do?',
    actions: {
      tryDifferentCard: 'Try again with a different card',
      tryDifferentCardDesc: 'Use another payment method',
      retryPayment: 'Retry the payment',
      retryPaymentDesc: 'Sometimes a simple retry works',
      checkBank: 'Check with your bank',
      checkBankDesc: 'Ensure your card has sufficient funds',
    },
    tryAgain: 'Try Upgrading Again',
    returnHome: 'Return to Main Page',
    contactSupport: 'Need help? Contact support at support@zodiac-chess.com',
  },

  // Donation
  donation: {
    title: 'Support Zodiac Chess',
    supportDevelopment: 'Support Development',
    story1: "Hi! Your support helps me continue improving this unique game! Adding new features, maintaining servers, and keeping Zodiac Chess free for the community.",
    story2: "Even a small donation makes a huge difference and keeps this project alive. Thank you for being part of the Zodiac Chess journey :)",
    selectAmount: 'Choose Amount',
    customAmount: 'Or enter custom amount:',
    total: 'Total:',
    donateButton: 'Donate Now',
    processing: 'Processing...',
    disclaimer: 'Donations support development and server costs. Thank you for your generosity!',
    invalidAmount: 'Please enter a valid amount greater than $0',
    error: 'There was an error processing your donation. Please try again.',
  },

  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'What is it about?',
    gameSetup: 'Game Setup',
    basicRules: 'Basic Rules',
    backButton: 'BACK',
    homeButton: 'Home',
    fullRules: 'Full Rules',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac is a two player abstract strategy game based off of Chess, Poker and DotA.',
      p2: 'It was created in 2014 as a crude version of itself called "Shadow Chess" based off its central principal of a secret king',
      p3: 'Later in 2018 it was redesigned to involve a roster of novel pieces with unique movement patterns and abilities',
      p4: "Zodiac's goal is to celebrate human intuition and novel play. To drive success toward a players ability to bluff and adapt to unfamiliar situations and create a nuanced set of challenges for the ever growing strength of AI",
      p5: "Another goal of Zodiac is to be a game for humans! With a very large search space for play, hidden information, win obfuscation and a changing roster of pieces over time. Zodiac wants to be a player data driven game that keeps creativity mainstay and staves off AI dominance",
      p6: 'We hope you stick around and see where this journey takes us',
    },

    // Setup section
    setup: {
      p1: "Players play a zodiac version of paper, scissors, rock to see who goes first!",
      p2: 'From there, select a piece to be your "King" your opponent won\'t know which one you have chosen.',
      p3: 'Then pick 5 pieces to play with, they all have different abilities, cohesion, strengths and weaknesses!',
      p4: 'Once you are both done the game will begin.',
      p5: 'Simply click on a piece to see where it can move to or click on any unhighlighted square to deselect the piece.',
      p6: 'Good luck!',
    },

    // Basic Rules section
    rules: {
      intro: 'The game of Zodiac is played by two players on a rectangle board made up of 40 squares (5 by 8).',
      toWinTitle: 'To win:',
      toWin1: 'Capture the opponents King',
      toWin2: '"Race" your King across the board',
      toWin3: 'Have your opponents timer expire',
      toWin4: 'Have your opponent surrender',
      drawTitle: 'A draw occurs',
      draw1: 'When a players king is still uncaptured and they cannot make any legal move, or;',
      draw2: 'The same board position is repeated three times',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'Regular movement - The Bear can move one square in any direction',
        desc2: 'The Bear\'s ability "Savage" allows it to capture any piece regardless of defensive abilities',
        desc3: 'The bear is a "large" piece and a "predator" piece meaning many of the other Zodiacs cannot capture it!',
      },
      crane: {
        desc1: 'The Crane can move 1 or 2 in any straight line for its regular movement',
        desc2: "The Crane cannot capture any 'large' or 'predator' pieces",
      },
      frog: {
        desc1: 'The frog can jump 2 on diagonals for its regular movement, even over other pieces!',
        desc2: "If the frog's regular movement is blocked by a wall or a piece it cannot capture, its regular movement is shortened to 1 square diagonally",
        desc3: "If the frog has yet to make a move in the game, it is on its 'lily pad' and can move to any of the first 3 ranks as a defensive movement",
        desc4: 'If a piece captures a frog, it becomes poisoned and cannot make any move for its next available turn',
        desc5: "The frogs special movement is 'wall climb' if a frog is beside the edge of the board, it can also move one up or down",
      },
      fungi: {
        desc1: 'The Fungi can move one in any direction for its regular movement',
        desc2: "The fungi's ability 'meadow' prevents a tree from moving if it is within one square of the fungi and does not allow a tree to move within one square of the enemy fungi",
        desc3: "When captured the fungi applies a 'zombie' effect to any animal piece that captured it",
        desc4: 'While zombified, the fungi controls the piece for the following turn and acts as the piece, meaning if the fungi was your king, you can still win by race victory or capturing the enemy king within that round',
      },
      goat: {
        desc1: 'The goat can move one in any direction for its regular movement',
        desc2: "The goats ability 'traverse' allows it to hop across linked pieces and then move, it cannot capture any piece on a traverse",
        desc3: "The goat cannot capture any 'predators'",
        desc4: "The goat can use a special ability called 'faint' to make itself appear dead",
        desc5: "While fainted, the goat is unable to be captured by most pieces but cannot move if another piece is 'standing' on it (on the same square)",
      },
      monkey: {
        desc1: 'The monkey can move one in any direction for its regular movement',
        desc2: "The monkey can 'leap' over friendly and enemy pieces like a checkers piece if the formation allows it",
        desc3: 'If the monkey does leap over an enemy piece it must roll a dice to not be captured! One danger point per enemy piece it leaps in a single line',
        desc4: 'The monkey CAN capture a bear if it decides to gamble to attack it, on a 1-4 roll on a six sided dice, the Monkey is captured, on a 5 or 6, the Monkey captures the bear',
        desc5: "The monkey has two abilities - 'swing' and 'consume' on a swing (a leap ending over a tree) the monkey gains an extra movement, on a consume of any fungi, the monkey also gains one extra movement before its turns end",
      },
      octopus: {
        desc1: 'The octopus can move one in any direction for its regular movement',
        desc2: 'The octopus may only capture on orthagonal squares',
        desc3: "The octopus can use its ability 'entangle' on any animal piece on diagonal squares",
        desc4: 'The octopus may make any move AND entangle in one turn',
        desc5: "The octopus has an ability called 'ink' with this ability it can move to any orthagonal square and place 'shadows' on the other 3 orthagonal squares if they are not occupied or off of the board. To the opponent for the round following the 'ink' ability the shadows and real octopus are indistinguishable",
      },
      penguin: {
        desc1: "The penguin has an ability called 'rotate' it is the only piece that has a set direction and may use the 'rotate' move to redirect its direction for its turn",
        desc2: "For the penguins regular movement 'slide' it must move to the furthest point in the direction it is facing and once there, it may use a rotate before its turns end to redirect its direction",
        desc3: "The penguin cannot capture any 'large' or 'predator' pieces. It can capture any other piece within one square of itself and use a rotate ability after the capture",
      },
      rhino: {
        desc1: "The rhino can move 'back left', 'back right' or two forward as part of its regular movement",
        desc2: "The rhino has an ability called 'trample' where captures ALL pieces in the path of its movement",
        desc3: 'Once per game a rhino may perform a charge of 3 squares ahead if any animal is present in any of the 3 squares directly infront of the rhino',
        desc4: 'The rhino has a special ability called "rhino defence" where the rhino cannot be captured from \'the front\'',
        desc5: "The rhino has an ability called 'lane' where if it has not moved and the friendly piece directly to its left or right has not moved, it can switch places with that piece for its turn",
      },
      snake: {
        desc1: 'The snake can move 2 squares only in orthagonal directions, including through other pieces for its regular movement',
        desc2: 'If its regular movement is blocked by a wall or a piece it cannot capture, its regular movement becomes 1',
        desc3: 'The snake has an ability called "strike" where if an animal is exactly 3 squares ahead of it and there are no pieces between, it can \'strike\' forward and capture that animal',
        desc4: 'The snake has an ability called "shed" where once per game if the snake is captured, it will return to the first rank of the board, in the same column, as if it had a second life. If the first rank is not a valid square for the snake to move to, it is permanently captured',
      },
      tree: {
        desc1: 'The tree may move one forward or unlimitedly side to side if not blocked by any other piece',
        desc2: "The tree has a special ability called 'house' where any piece that can 'climb' tree's may sit on top of the tree piece. If an enemy piece attacks a tree with a housed piece, the housed piece is captured and the tree houses the enemy piece",
        desc3: 'When a piece is housed in the tree, if an enemy piece cannot climb the tree, both the tree and the housed piece are protected from capture',
      },
      wolf: {
        desc1: 'The wolf moves in an L shape like a knight in chess for its regular movement',
        desc2: "If the wolf is the last piece on the board* it's ability 'lone wolf' is activated and it moves in a long L instead as pictured above. *The wolf will enter lone if on a team with a fainted goat or infecting virus",
      },
      virus: {
        desc1: "The virus may move 2 squares in any straight line for its regular movement, it does not capture but uses its ability 'infect' to cause the piece to be infected rather than captured",
        desc2: "The virus can only move to any animal piece, if blocked by a wall, the virus's regular movement is only 1 square",
        desc3: "When an animal piece is 'infected' if the virus leaves the infected piece in to another piece, the piece it left is captured and the new piece is 'infected'",
        desc4: "The virus has an ability called 'infectious' which allows the virus to complete as many valid moves in one move as it likes, capturing multiple animals in one turn",
        desc5: "While not 'infecting' the virus can be captured like any other piece, if an animal captures an infected piece, it becomes infected",
      },
    },
  },
};

export type TranslationKeys = typeof en;
